  <template>
  <div>
    <div v-for="course in courses" :key="course.id">
      <div>{{course.code}} - {{course.title}}</div>
      <v-simple-table>
        <template v-slot:default>
          <thead>
            <tr>
              <th class="text-left">ID</th>
              <th class="text-left">Name</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="exam in course.exams" :key="exam.id">
              <td>{{ exam.id }}</td>
              <td>
                <router-link :to="'/next/' + exam.questionOrder.id">{{ exam.name }}</router-link>
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
      <br />
      <br />
    </div>
  </div>
</template>


<script>
export default {
  name: "StuCourses",

  methods: {},

  data() {
    return {
      courses: [{exams: [{id: 0}], id: 0}]
    };
  },

  async mounted() {
    var response = await fetch(
      process.env.VUE_APP_API_BASE_URL + "/student/view/",
      {
        method: "GET",
        credentials: "include",
        headers: {
          "Content-Type": "application/json"
          // 'Content-Type': 'application/x-www-form-urlencoded',
        }
      }
    );

    if (response.ok) {
      var data = await response.json();
      console.log(data);
      // alert(JSON.stringify(data));
      this.courses = data;
    } else {
      alert(response.status + ": " + response.statusText);
    }
  }
};
</script>